/* pdp-reviews.js — the product page's reviews band. The first five reviews and the star counts are in the page
   (from Judge.me's product metafields); this adds "Read more" on long reviews, "Show 5 more" and the star filters,
   reading Judge.me's public widget endpoint (the same one its own widget uses). Built with textContent only. */
(function () {
  var SHOP = 'stonegrindzchocolate.myshopify.com';
  var API = 'https://api.judge.me/reviews/reviews_for_widget';
  var PER = 5;
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var WORD = { 5: 'five', 4: 'four', 3: 'three', 2: 'two', 1: 'one' };

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function stars(n, cls, label) {
    var s = el('span', 'rvx-stars ' + cls);
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', label);
    s.style.setProperty('--pct', n * 20 + '%');
    s.appendChild(el('span', 'rvx-stars-bg'));
    s.appendChild(el('span', 'rvx-stars-fg'));
    return s;
  }
  // dates in the shop's own time zone (Arizona), the same as the five the page prints
  function fmt(iso) {
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try {
      return d.toLocaleDateString('en-US', { timeZone: 'America/Phoenix', month: 'short', day: 'numeric', year: 'numeric' });
    } catch (e) {
      var a = new Date(d.getTime() - 7 * 3600000);
      return MON[a.getUTCMonth()] + ' ' + a.getUTCDate() + ', ' + a.getUTCFullYear();
    }
  }
  function ymd(iso) {
    var d = new Date(new Date(iso).getTime() - 7 * 3600000);
    return isNaN(d) ? '' : d.toISOString().slice(0, 10);
  }

  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function (r) {
      var q = function (s) { return r.querySelector(s); };
      var rt = q('.jdgm-rev__rating');
      var score = rt ? parseInt(rt.getAttribute('data-score'), 10) || 0 : 0;
      var t = q('.jdgm-rev__timestamp');
      var body = q('.jdgm-rev__body');
      var paras = body ? Array.prototype.map.call(body.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).filter(Boolean) : [];
      if (!paras.length && body && body.textContent.trim()) paras = [body.textContent.trim()];
      var pics = Array.prototype.map.call(r.querySelectorAll('.jdgm-rev__pics a.jdgm-rev__pic-link'), function (a) {
        var img = a.querySelector('img');
        return { full: a.getAttribute('href') || '', thumb: img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '' };
      }).filter(function (p) { return /^https:\/\//.test(p.full) && /^https:\/\//.test(p.thumb); });
      var reply = q('.jdgm-rev__reply');
      return {
        id: r.getAttribute('data-review-id') || '',
        score: score,
        ver: r.getAttribute('data-verified-buyer') === 'true',
        date: t ? (t.getAttribute('datetime') || (t.getAttribute('data-content') || '').replace(' UTC', 'Z').replace(' ', 'T')) : '',
        author: ((q('.jdgm-rev__author') || {}).textContent || '').trim(),
        title: ((q('.jdgm-rev__title') || {}).textContent || '').trim(),
        paras: paras,
        pics: pics.slice(0, 4),
        reply: reply ? reply.textContent.replace(/\s+/g, ' ').trim() : ''
      };
    });
  }

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  // a stars-only review: Judge.me puts the product's name where the words would be ("Ancient Ecuador 85%")
  function nameOnly(r, title) {
    if (r.paras.length !== 1) return false;
    var b = r.paras[0];
    return norm(b) === norm(title) || (b.length < 90 && /\*[^*]+\*\s*$/.test(b));
  }

  function card(r, seal) {
    var li = el('li', 'rvx-card is-new');
    li.setAttribute('data-id', r.id);
    var top = el('div', 'rvx-top');
    top.appendChild(stars(r.score, 'rvx-stars-sm', 'Rated ' + r.score + ' out of 5'));
    var ds = fmt(r.date);
    if (ds) {
      var t = el('time', 'rvx-date', ds);
      t.setAttribute('datetime', ymd(r.date));
      top.appendChild(t);
    }
    li.appendChild(top);
    if (r.title) li.appendChild(el('p', 'rvx-h', r.title));
    if (r.paras.length) {
      var b = el('div', 'rvx-body');
      r.paras.forEach(function (p) { b.appendChild(el('p', null, p)); });
      li.appendChild(b);
      var more = el('button', 'rvx-more', 'Read more');
      more.type = 'button';
      more.hidden = true;
      more.setAttribute('aria-expanded', 'false');
      li.appendChild(more);
    }
    if (r.pics.length) {
      var ul = el('ul', 'rvx-pics');
      ul.setAttribute('role', 'list');
      r.pics.forEach(function (u) {
        var a = el('a');
        a.href = u.full; a.target = '_blank'; a.rel = 'noopener nofollow';
        a.setAttribute('aria-label', 'Photo from ' + (r.author || 'this reviewer') + ', opens in a new tab');
        var img = el('img');
        img.src = u.thumb; img.alt = ''; img.loading = 'lazy'; img.width = 76; img.height = 76;
        a.appendChild(img);
        var w = el('li'); w.appendChild(a); ul.appendChild(w);
      });
      li.appendChild(ul);
    }
    var who = el('p', 'rvx-who');
    who.appendChild(el('span', 'rvx-name', r.author || 'A customer'));
    if (r.ver && seal) {
      var v = el('span', 'rvx-ver');
      v.appendChild(seal.cloneNode(true));
      v.appendChild(document.createTextNode('Verified buyer'));
      who.appendChild(v);
    }
    li.appendChild(who);
    if (r.reply) {
      var rp = el('div', 'rvx-reply');
      rp.appendChild(el('p', 'rvx-reply-h', 'Stone Grindz replied'));
      rp.appendChild(el('p', null, r.reply));
      li.appendChild(rp);
    }
    return li;
  }

  function clampAll(root) {
    root.querySelectorAll('.rvx-card').forEach(function (c) {
      var b = c.querySelector('.rvx-body');
      var m = c.querySelector('.rvx-more');
      if (!b || !m || c.hasAttribute('data-clamp')) return;
      c.setAttribute('data-clamp', '');
      b.classList.add('is-clamped');
      if (b.scrollHeight - b.clientHeight > 4) {
        m.hidden = false;
        m.addEventListener('click', function () {
          var open = m.getAttribute('aria-expanded') === 'true';
          b.classList.toggle('is-clamped', open);
          m.setAttribute('aria-expanded', open ? 'false' : 'true');
          m.textContent = open ? 'Read more' : 'Show less';
        });
      } else {
        b.classList.remove('is-clamped');
      }
    });
  }

  function init(root) {
    var pid = root.getAttribute('data-pid');
    var total = parseInt(root.getAttribute('data-count'), 10) || 0;
    var since = parseInt(root.getAttribute('data-since') || '0', 10) * 1000;
    var list = root.querySelector('.rvx-list');
    var next = root.querySelector('.rvx-next');
    var shown = root.querySelector('.rvx-shown');
    var load = root.querySelector('[data-rvx-load]');
    var dist = root.querySelector('.rvx-dist');
    var chip = root.querySelector('.rvx-filter');
    var chipT = chip && chip.querySelector('.rvx-filter-t');
    var seal = root.querySelector('.rvx-seal');
    var ptitle = root.getAttribute('data-title') || '';
    var qkey = norm(root.getAttribute('data-quote') || '');
    if (!list) return;
    var first = Array.prototype.slice.call(list.children);
    var shown0 = parseInt(root.getAttribute('data-shown'), 10) || first.length;
    var state = { star: 0, page: 1, count: shown0, total: total, busy: false, done: !since };
    var counts = {};
    if (dist) dist.querySelectorAll('.rvx-row').forEach(function (b) {
      counts[b.getAttribute('data-star')] = parseInt((b.querySelector('.rvx-row-n') || {}).textContent, 10) || 0;
    });

    function paint() {
      if (shown) shown.textContent = 'Showing ' + state.count + ' of ' + state.total + (since && !state.done ? '+' : '');
      if (next) next.hidden = (since ? state.done : state.count >= state.total) && !state.err;
      if (load) {
        var left = state.total - state.count;
        load.querySelector('.pop-face').textContent = state.err ? 'Try again' : (since || left >= PER ? 'Show ' + PER + ' more' : 'Show the last ' + (left === 1 ? 'one' : left));
        load.setAttribute('aria-busy', state.busy ? 'true' : 'false');
      }
    }

    function url(page) {
      var u = API + '?url=' + SHOP + '&shop_domain=' + SHOP + '&platform=shopify&product_id=' + encodeURIComponent(pid) + '&per_page=' + PER + '&page=' + page;
      if (state.star) u += '&filter_rating=' + state.star;
      return u;
    }

    function fetchPage(page, replace) {
      state.busy = true; state.err = false; paint();
      list.setAttribute('aria-busy', 'true');
      var star = state.star;
      return fetch(url(page), { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (d) {
        if (star !== state.star) return;
        var raw = parse(d.html || '');
        var rows = raw;
        var ended = !raw.length;
        // a weekly-release item: only this run's reviews (older ones belong to the flavors this product used to be)
        if (since) {
          rows = raw.filter(function (r) { return Date.parse(r.date) >= since; });
          if (rows.length < raw.length) ended = true;
        }
        if (replace) list.textContent = '';
        var have = {};
        list.querySelectorAll('.rvx-card').forEach(function (c) { have[c.getAttribute('data-id')] = 1; });
        rows.forEach(function (r) {
          if (have[r.id]) return;
          state.count++;
          if (nameOnly(r, ptitle)) r.paras = [];
          if (qkey.length > 11 && r.paras.length && norm(r.paras.join(' ')).slice(0, qkey.length) === qkey) return;
          list.appendChild(card(r, seal));
        });
        state.page = page;
        if (ended || (since && raw.length < PER)) { state.total = state.count; state.done = true; }
        clampAll(list);
      }).catch(function () {
        state.err = true;
      }).then(function () {
        state.busy = false;
        list.removeAttribute('aria-busy');
        paint();
      });
    }

    function setStar(s) {
      state.star = s;
      if (dist) {
        dist.classList.toggle('is-filtered', !!s);
        dist.querySelectorAll('.rvx-row').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-star') === String(s)));
        });
      }
      if (chip) {
        chip.hidden = !s;
        if (s && chipT) chipT.textContent = s + '-star reviews only';
      }
      if (!s) {
        list.textContent = '';
        first.forEach(function (c) { c.classList.remove('is-new'); list.appendChild(c); });
        state.count = shown0; state.total = total; state.page = 1; state.err = false;
        paint();
        return;
      }
      state.total = counts[s] || 0; state.count = 0; state.page = 0;
      fetchPage(1, true);
    }

    if (load) load.addEventListener('click', function () {
      if (state.busy) return;
      fetchPage(state.page + 1, false);
    });
    if (dist) dist.addEventListener('click', function (e) {
      var b = e.target.closest('.rvx-row');
      if (!b || b.disabled) return;
      var s = parseInt(b.getAttribute('data-star'), 10);
      setStar(state.star === s ? 0 : s);
      var top = root.querySelector('.rvx-main');
      if (top && window.matchMedia('(max-width:899px)').matches) {
        var y = top.getBoundingClientRect().top;
        if (y > window.innerHeight * .8 || y < 0) top.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    });
    var clr = root.querySelector('[data-rvx-clear]');
    if (clr) clr.addEventListener('click', function () { setStar(0); if (dist) { var p = dist.querySelector('.rvx-row'); if (p) p.focus({ preventScroll: true }); } });
    clampAll(list);
    paint();
  }

  function boot() { document.querySelectorAll('[data-rvx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
